import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CreditCardIcon, StarIcon, UsersIcon, BookOpenIcon, SparklesIcon } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/9EeDhCRWo9yRx2H5ZuSWcb/Mockup_stretching_360-Photoroom.png';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative overflow-hidden bg-[#071d27] pt-12 pb-10 md:pt-24 md:pb-16" data-id="element-169" data-mp="128yz6bncnty4">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_85%_15%,rgba(45,212,191,0.18),transparent_28%),radial-gradient(circle_at_15%_90%,rgba(26,74,94,0.55),transparent_36%)]" data-id="element-170" data-mp="xaxg3qpxbumn" />
      <div className="absolute top-0 left-0 w-full h-px bg-brand-accent/30" data-id="element-171" data-mp="nbf0fmh1qv0e" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-172" data-mp="3d1sa6w93nhsl">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_0.9fr] gap-6 lg:gap-12 items-center" data-id="element-173" data-mp="382p9fo05jxqf">
          <motion.div initial={{
          opacity: 0,
          x: -28
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.55
        }} className="text-center lg:text-left" data-id="element-174" data-mp="3j8sfe0v2xjpu">
            <div className="inline-flex items-center gap-2 rounded-full border border-brand-accent/30 bg-brand-accent/10 px-3 py-1.5 text-[11px] font-bold tracking-[0.16em] text-brand-accent mb-4" data-id="element-175" data-mp="399bctsb4jly3">
              <SparklesIcon className="w-3.5 h-3.5" data-id="element-176" data-mp="30gztsricb0s5" />
              STRETCHING 360™
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-black leading-[1.04] mb-4 text-white" data-id="element-177" data-mp="359jahxcbqc16">
              Tu año de Stretching,{' '}
              <span className="text-brand-accent" data-id="element-178" data-mp="2viewp0ydwx7x">completamente resuelto.</span>
            </h1>

            <motion.div initial={{
            opacity: 0,
            scale: 0.92
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.12
          }} className="relative my-3 lg:hidden flex justify-center" data-id="element-179" data-mp="2hinaicxpsaiu">
              <div className="absolute inset-5 rounded-full bg-brand-accent/20 blur-[70px]" data-id="element-180" data-mp="nat65811aej4" />
              <img src={PRODUCT_IMAGE} alt="Sistema Stretching 360 con los 6 tomos, bonos y Cuerpo Seguro Pro" className="relative z-10 w-[84%] max-w-sm mx-auto drop-shadow-2xl" data-id="element-181" data-mp="ibyoi9esyw0l" />
            </motion.div>

            <p className="text-base md:text-xl text-gray-100 mb-3 font-semibold" data-id="element-182" data-mp="1b1fe6zb1fyt4">
              6 Tomos · 60+ Clases · 5 Bonos · Cuerpo Seguro Pro incluido.
            </p>
            <p className="text-sm md:text-lg text-gray-300 mb-6 max-w-xl mx-auto lg:mx-0" data-id="element-183" data-mp="15zzqt0le1g7k">
              Clases, técnica, progresión, adaptaciones y comunicación profesional para enseñar con un sistema real. Sin improvisar.
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-6" data-id="element-184" data-mp="3lu04j5ufbd1u">
              <span className="flex items-center text-xs sm:text-sm bg-white/5 border border-white/10 px-2.5 py-1 rounded-md text-gray-100" data-id="element-185" data-mp="3hqah4jphj1ie">
                <BookOpenIcon className="w-3.5 h-3.5 mr-1.5 text-brand-accent" data-id="element-186" data-mp="1x7869rdijxvp" /> PDF digital
              </span>
              <span className="flex items-center text-xs sm:text-sm bg-white/5 border border-white/10 px-2.5 py-1 rounded-md text-gray-100" data-id="element-187" data-mp="269zivui4kzox">
                <StarIcon className="w-3.5 h-3.5 mr-1.5 text-brand-accent" data-id="element-188" data-mp="2b1r9u65717fl" /> Acceso inmediato
              </span>
              <span className="flex items-center text-xs sm:text-sm bg-white/5 border border-white/10 px-2.5 py-1 rounded-md text-gray-100" data-id="element-189" data-mp="2fz0znmwhvl3y">
                <UsersIcon className="w-3.5 h-3.5 mr-1.5 text-brand-accent" data-id="element-190" data-mp="2p0h7pnzu7b50" /> Todos los niveles
              </span>
            </div>

            <motion.button whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.98
          }} onClick={scrollToPricing} className="w-full sm:w-auto bg-brand-accent hover:bg-brand-accentHover text-brand-dark font-black text-base md:text-lg px-6 py-4 rounded-xl shadow-[0_0_32px_rgba(45,212,191,0.35)] transition-all" data-id="element-191" data-mp="2tztvcayj8m8n">
              QUIERO MI STRETCHING 360 →
            </motion.button>

            <div className="mt-5 flex flex-wrap items-center justify-center lg:justify-start gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-300" data-id="element-192" data-mp="3vgvxcsqubh69">
              <div className="flex items-center" data-id="element-193" data-mp="9ah313lwwly6"><ShieldCheckIcon className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-194" data-mp="9a79j61nrwnq" /> Garantía 7 días</div>
              <div className="flex items-center" data-id="element-195" data-mp="3hrbxbuon8y0n"><ShieldCheckIcon className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-196" data-mp="3hqjzed7kqo77" /> Pago 100% seguro</div>
              <div className="flex items-center" data-id="element-197" data-mp="3ct0mbgmm4hgu"><CreditCardIcon className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-198" data-mp="3rfttfylzagxy" /> Mercado Pago | Tarjeta</div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 28
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.16
        }} className="relative hidden lg:block" data-id="element-199" data-mp="3molll70ar3mw">
            <div className="absolute inset-8 rounded-full bg-brand-accent/20 blur-[110px]" data-id="element-200" data-mp="19ixci09itial" />
            <img src={PRODUCT_IMAGE} alt="Sistema Stretching 360 con los 6 tomos, bonos y Cuerpo Seguro Pro" className="relative z-10 w-full max-w-xl mx-auto drop-shadow-[0_24px_36px_rgba(0,0,0,0.5)]" data-id="element-201" data-mp="1e9dpjj9fj1wf" />
          </motion.div>
        </div>

        
      </div>
    </section>;
}
function Metric({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="text-center" data-id="element-202" data-mp="1s9og0l6tueh2">
      <div className="text-2xl md:text-4xl font-display font-bold text-white mb-0.5" data-id="element-203" data-mp="1x883iq12jybj">{value}</div>
      <div className="text-brand-accent text-[11px] md:text-sm font-bold tracking-wide" data-id="element-204" data-mp="1j8gvr715be5z">{label}</div>
    </div>;
}